<network-selection [isMultiple]="false"
                   [sortItems]="true"
                   [model]="dialogConfig.dialogData.entity.id"
                   (acChanged)="dialogConfig.dialogData.entity.id = $event"
                   [items]="dialogConfig.dialogData.lcCustomers"
                   formFieldName="dialogConfig.dialogData.entity.id"
                   type="LC_CUSTOMER">
</network-selection>

